import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as types from 'modules/types/smSupplierManagement';
import { FilterOptionsArray } from 'modules/types/commons/filter';
import { Prompt } from 'react-router-dom';
import { NoData } from '@beehive/components';
import _ from 'lodash';
import { QuerySelectorHTMLElement } from 'modules/types/commons/dom';
import { AlertProps } from 'components/showAlertHOC';
import { ScrollHelper } from 'utils';
import PropTypes from 'prop-types';
import globalMessages from 'messages';

const messages = { ...globalMessages };

/**
 * 编辑来源，myRecommendSupplier我的推荐, supplierAudit供应商评审, supplierManagement供应商管理
 */
export type EditType = 'myRecommendSupplier' | 'supplierAudit' | 'supplierManagement';

export interface ParamsType {
  supplierId: string;
}

export interface EditProps extends RouteComponentProps<ParamsType> {
  getDetail: any;
  onSave: any;
  onChange: any;
  onAudit?: any;
  prefixCls: string;
  data: types.SupplierMangementDetail;
  editType?: EditType;
  /**
   * 是否是编辑状态
   */
  isEdit?: boolean;
  /**
   * 是否是新建状态
   */
  isNew?: boolean;
  auditItemsResult: { [k: string]: boolean };
  showAlert: (params: AlertProps) => void;
  handlePushShowPage?: any;
  handleCancel?: any;
  handleSave?: any;
  getFilters?: any;
  filters?: FilterOptionsArray;
  cancelUrl?: string;
  getAttachementUploadUrl?: () => string;
}

export interface EditOptions {
  /**
   * 取消时返回的页面
   */
  cancelUrl?: string;
}

const SupplierEditHoc = (WrappedComponent: any, editOptions: EditOptions = {}) => {
  return class extends React.Component<EditProps, any> {
    public static defaultProps = {
      prefixCls: 'mpc-ext-company-info',
      isEdit: true,
    };

    public static contextTypes = {
      intl: PropTypes.object,
    };

    constructor(props: EditProps) {
      super(props);
    }

    public componentDidMount() {
      this.getEditDetail();
    }

    public componentWillReceiveProps(nextProps: EditProps) {
      const { match: { params: { supplierId } } } = this.props;
      const { match: { params: { supplierId: nextSupplierId } } } = nextProps;
      if (supplierId !== nextSupplierId) {
        this.getEditDetail({ supplierId: nextSupplierId });
      }
    }

    private getEditDetail = (options: any = {}) => {
      const { getDetail, match: { params: { supplierId } }, isEdit, isNew, showAlert } = this.props;
      options = Object.assign({
        supplierId,
        isEdit,
        isNew,
      }, options);

      getDetail({ id: +options.supplierId }, { isEdit: options.isEdit, isNew: options.isNew }).catch((err: any) => {
        showAlert({ type: 'error', message: err.message });
      });
    }

    // 跳转到详情页
    private handlePushShowPage = () => {
      const { history, cancelUrl: propCancelUrl } = this.props;
      const { cancelUrl = '/' } = editOptions;
      history.push(propCancelUrl || cancelUrl);
    }

    private handleCancel = () => {
      const { history, cancelUrl: propCancelUrl } = this.props;
      const { cancelUrl = '/' } = editOptions;
      history.push({
        ...this.props.history.location,
        pathname: propCancelUrl || cancelUrl,
      });
    }

    private handleBlur = () => {
      const focusEle: QuerySelectorHTMLElement = document.querySelector('.form-item-element *:focus');
      if (focusEle) {
        focusEle.blur();
      }
    }

    private handleSave = (body = {}) => {
      const { intl } = this.context;
      const { onSave, showAlert, isNew } = this.props;
      onSave(body, isNew).then((res: any) => {
        showAlert({
          type: 'success',
          message: intl.formatMessage(messages.saveSuccess),
          afterClose: () => {
            this.handlePushShowPage();
          },
        });
      }).catch((error: any) => {
        if (typeof error === 'object' && 'messages' in error) {
          const errMsgs: any[] = _.values(_.get(error, 'messages', []));
          showAlert({ type: 'error', message: errMsgs.join(';') });
          ScrollHelper.scrollToFormFirstError();
        } else {
          showAlert({
            type: 'error', message: typeof error === 'string'
              ? error : intl.formatMessage(messages.serverErrorTips),
          });
        }
      });
    }

    public render() {
      const { intl } = this.context;
      const { data: { hasChanged, hasGetError } } = this.props;
      return (
        <React.Fragment>
          <Prompt
            when={hasChanged}
            message={intl.formatMessage(messages.pageLeaveTipContent)}
          />
          {hasGetError ? <NoData type="404" text={intl.formatMessage(messages.notFoundPageMessage)} /> : (
            <WrappedComponent
              handlePushShowPage={this.handlePushShowPage}
              handleCancel={this.handleCancel}
              handleSave={this.handleSave}
              {...this.props}
            />
          )}
        </React.Fragment>
      );
    }
  };
};

export default SupplierEditHoc;
